import gql from 'graphql-tag'

const UPDATE_STORE_INTEGRATION = gql`
  mutation UpdateStoreIntegrationSettings(
    $partnerName: PartnerName!
    $storeId: uuid!
    $lightspeedBusinessId: Int
    $lightspeedBusinessName: String
    $lightspeedMenus: [LightspeedMenuInput]
    $lightspeedBusinessLocationId: Int
    $lightspeedBusinessLocationName: String
    $lightspeedOrderProfileMapping: LightspeedOrderProfileMappingInput
    $lightspeedScheduledOrderBufferSamedayMinutes: Int
    $lightspeedScheduledOrderBufferPreorderMinutes: Int
  ) {
    updateStoreIntegrationSettings(
      partnerName: $partnerName
      storeId: $storeId
      lightspeedBusinessId: $lightspeedBusinessId
      lightspeedBusinessName: $lightspeedBusinessName
      lightspeedMenus: $lightspeedMenus
      lightspeedBusinessLocationId: $lightspeedBusinessLocationId
      lightspeedBusinessLocationName: $lightspeedBusinessLocationName
      lightspeedOrderProfileMapping: $lightspeedOrderProfileMapping
      lightspeedScheduledOrderBufferSamedayMinutes: $lightspeedScheduledOrderBufferSamedayMinutes
      lightspeedScheduledOrderBufferPreorderMinutes: $lightspeedScheduledOrderBufferPreorderMinutes
    ) {
      integrationSettings {
        lightspeedMenus {
          id
          name
          orderType
        }
        lightspeedBusinessId
        lightspeedBusinessName
        lightspeedLastMenuPushAt
        lightspeedBusinessLocationId
        lightspeedBusinessLocationName
        lightspeedOrderProfileMapping {
          delivery
          pickup
          orderAtTable
        }
        lightspeedScheduledOrderBufferSamedayMinutes
        lightspeedScheduledOrderBufferPreorderMinutes
      }
    }
  }
`

const FETCH_MENUS = gql`
  query GetMenus($partnerName: PartnerName!, $storeId: uuid!) {
    fetchPartnerMenus(partnerName: $partnerName, storeId: $storeId) {
      id
      name
    }
  }
`

const REQUEST_PUSH_MENU = gql`
  mutation RequestMenuPush($partnerName: PartnerName!, $storeId: uuid!) {
    requestMenuPush(partnerName: $partnerName, storeId: $storeId) {
      integrationSettings {
        lightspeedLastMenuPushAt
      }
    }
  }
`

const GET_LIGHTSPEED_ORDER_PROFILES = gql`
  query GetLightspeedOrderProfiles($storeId: uuid!) {
    getLightspeedOrderProfiles(storeId: $storeId) {
      code
      deliveryMode
    }
  }
`

const GET_AUTH_URL = gql`
  query GetAuthURL($partnerName: PartnerName!) {
    getOauthAuthorizationUrl(partnerName: $partnerName)
  }
`

const UPDATE_MERCHANT_INTEGRATION_SETTINGS = gql`
  mutation UpdateMerchantIntegrationSettings(
    $lightspeed_loyalty_enabled: Boolean!
    $lightspeed_loyalty_auth_password: String!
  ) {
    updateMerchantIntegrationSettings(
      lightspeedLoyaltyEnabled: $lightspeed_loyalty_enabled
      lightspeedLoyaltyAuthPassword: $lightspeed_loyalty_auth_password
    ) {
      lightspeedLoyaltyEnabled
      lightspeedLoyaltyUsername
      lightspeedLoyaltyPasswordSet
    }
  }
`

const UPDATE_MERCHANT_LOYALTY_ENABLED = gql`
  mutation UpdateMerchantLoyaltyEnabled($lightspeed_loyalty_enabled: Boolean!) {
    updateMerchantIntegrationSettings(
      lightspeedLoyaltyEnabled: $lightspeed_loyalty_enabled
    ) {
      lightspeedLoyaltyEnabled
      lightspeedLoyaltyUsername
      lightspeedLoyaltyPasswordSet
    }
  }
`

const GET_MERCHANT_INTEGRATIONS = gql`
  query GetMerchantIntegrations {
    getMerchantIntegrations {
      lightspeedLoyaltyEnabled
      lightspeedLoyaltyPasswordSet
      lightspeedLoyaltyUsername
    }
  }
`

export {
  UPDATE_STORE_INTEGRATION,
  FETCH_MENUS,
  REQUEST_PUSH_MENU,
  GET_LIGHTSPEED_ORDER_PROFILES,
  GET_AUTH_URL,
  UPDATE_MERCHANT_INTEGRATION_SETTINGS,
  UPDATE_MERCHANT_LOYALTY_ENABLED,
  GET_MERCHANT_INTEGRATIONS
}
